import { Col, LiveBadge, Row, Text } from 'components';
import { format, isThisYear } from 'date-fns';
import { normalizeDate } from 'lib';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { TableComponents } from 'screens/Admin/components';

const ListItem = memo(({ item, onClick = null, isSelected }) => {
  const { sport, winner, home, away, progress, gameStatus, status, score } = item;
  const isLive = status == 'live';
  const date = new Date(item.date);
  const { Tr, Td } = TableComponents;
  const { t } = useTranslation();

  return (
    <Tr onClick={() => onClick(item._id)} isSelected={isSelected}>
      <Td isSelected={isSelected}>
        <Text>{t(`sports.${sport}`)}</Text>
      </Td>

      <Td isSelected={isSelected}>
        <Col noFlex start>
          <Row noFlex>
            <Text b2 bold={winner === 'home'}>
              {home.name}
            </Text>

            <Text b2 marg="0 0 0 5px" bold={winner === 'home'}>
              {score?.home || ''}
            </Text>
          </Row>

          <Row>
            <Text b2 bold={winner === 'away'}>
              {away.name}
            </Text>

            <Text b2 marg="0 0 0 5px" bold={winner === 'away'}>
              {score?.away || ''}
            </Text>
          </Row>
        </Col>
      </Td>

      <Td isSelected={isSelected}>
        <Text>{item.venue || item.stadium}</Text>
      </Td>

      <Td isSelected={isSelected}>
        <Row noFlex>
          <Text marg={isLive && '0 10px 0 0 '}>
            {isThisYear(date) ? '' : `${format(date, 'yyyy')} `}
            {normalizeDate(date, null, t)}
          </Text>

          {isLive && <LiveBadge {...item} isAdmin />}
        </Row>
      </Td>
    </Tr>
  );
});

export default ListItem;
